export default __webpack_public_path__ + "static/media/main.aa92204c.png";